import { SortOptions } from "../../pages/Visualization";
import { Keyword } from "../../types/Keyword";
import { Parameter } from "../../types/Parameter";
import Sort from "../Sort/Sort";

type RepoSideBarProps = {
  keywords: Keyword[];
  parameters: Parameter[];
  selectedParameter?: Parameter | null;
  repoId: string | null;
  onKeywordHover?: (keyword: Keyword | null) => void;
  onKeywordLeave?: () => void;
  onKeywordClick?: (keyword: Keyword) => void;
  onParameterHover?: (parameter: Parameter | null) => void;
  onParameterLeave?: () => void;
  isVisualization: boolean;
  onSort: ({ type, parameterKey, order }: SortOptions) => void;
  resetZoom?: () => void;
  onParameterClick?: (parameter: Parameter) => void;
};

const RepoSideBar = (props: RepoSideBarProps) => {
  // const { value: methodology, valueChangeHandler: methodologyChangeHandler, inputBlurHandler: methodologyBlurHandler } = useInput('');

  return (
    <div className="col-md-3 right-col p-0">
      <button onClick={props.resetZoom} className="btn reset-zoom">
        Reset Zoom
      </button>
      {props.isVisualization && (
        <Sort parameters={props.parameters} onSort={props.onSort} />
      )}
      <div className="parameter-box">
        <h4 className="title">Repository Keywords</h4>
        <div className="list-items scrollable">
          <div id="form-tags-2_tagsinput" className="tagsinput">
            {props.keywords &&
              props.keywords.map((keyword, index) => (
                <span
                  className="tag"
                  key={index}
                  onMouseEnter={() =>
                    props.onKeywordHover && props.onKeywordHover(keyword)
                  }
                  onMouseLeave={props.onKeywordLeave}
                  onClick={(e) => {
                    e.preventDefault();
                    props.onKeywordClick && props.onKeywordClick(keyword); // Call the callback on click
                  }}
                >
                  <span className="tag-text">{keyword.keyword}</span>
                </span>
              ))}
          </div>
        </div>
      </div>

      <div className="parameter-box">
        <h4 className="title">Repository Parameters</h4>
        <div className="list-items scrollable">
          <div id="form-tags-2_tagsinput" className="tagsinput">
            {props.parameters &&
              props.parameters.map((parameter, index) => (
                <span
                  className={`tag ${props.selectedParameter?.key === parameter.key ? "selected" : ""}`}
                  key={index}
                  onMouseEnter={() =>
                    props.onParameterHover && props.onParameterHover(parameter)
                  }
                  onMouseLeave={props.onParameterLeave}
                  onClick={(e) => {
                    e.preventDefault();
                    props.onParameterClick && props.onParameterClick(parameter); // Call the callback on click
                  }}
                >
                  <span className="tag-text">{parameter.key}</span>
                </span>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default RepoSideBar;
